// import { Suspense } from "react";
import React from "react";
import {Modal, notifyLoading, notifyError} from "../modal.js";
// import LoadingSpinner from './loadingSpinner.mjs';
import OrderingGrid from './orderingGrid.js';
import { fetchJson } from "../fetch.js";
// const OrderingGrid = React.lazy(() => import('./orderingGrid.js'));
import BudgetModal from "./budgetConsequences.js";
import {PubSub} from '../weave/helpers.mjs';

class OrderingGridModal extends React.Component {
    /* constructor(props) {
        super(props);
        this.state = {
            data: null
        };
    } */

    /* componentDidMount() {
        PubSub.sub("orderingGridInit", this.init.bind(this));
    }

    init(data) {
        this.setState({
            data: data
        });
    } */

    onConfirm(next=false) {
        notifyLoading('Saving...');
        const form = document.getElementById("orderingGrid");
        const orderingGridFormData = new FormData(form);

        var url = "/basketBranch/add/" + this.props.data.basketId + "/" + this.props.data.prId;
        if (this.props.fromBookshelf) {
            url = "/basketBranch/fromBookshelf/" + this.props.fromBookshelf + "/" + this.props.data.basketId;
        }
        if (this.props.basketBuilderData && this.props.basketBuilderData.length > 0) {
            var bbData = this.props.basketBuilderData;
            url = "/search/fromBasketBuilder/" + bbData[0].basketValue;
            if (bbData[0].profileId) {
                url += "/" + bbData[0].profileId;
            } else {
                var defaultProfileId = 0; // NO PROFILE ID SELECTED
                url += "/" + defaultProfileId;
            }
            url += "/" + this.props.data.basketId;

            var basketBuilderClass = $("#basketBuilderModal").attr("class");
            // Basket builder via boolean search page
            if (basketBuilderClass == "booleanBasketBuilder") {
                orderingGridFormData.append("searchPageType", "boolean");
                updateFilterItemArray();
                orderingGridFormData.append("searchFilterItems", JSON.stringify(filterItems));
            }
            // Basket builder via advanced search page
            else if (basketBuilderClass == "advancedBasketBuilder") {
                orderingGridFormData.append("searchPageType", "advanced");
                const advancedSearchFormData = new FormData($('#searchForm')[0]);
                for (var pair of advancedSearchFormData.entries()) {
                    orderingGridFormData.append(pair[0], pair[1]);
                }
            }
        }
        fetchJson(url, orderingGridFormData).then(r => {
            if (r.error) {
                notifyError(r.error); // "No search filters" for example
            }
            PubSub.pub("saveOrderingGrid", this.props.data.prId, r.newTotalQuantity);
            PubSub.pub("addToBasketModal_close");
            if (r.unavailable) {
                notifyError("The following unavailable titles were not added", r.unavailable.join(", "));
            }
            if (next == true) {
                PubSub.pub("goToNextResult", this.props.data.prId);
            }
        });
    }

    render() {
        if (!this.props.data) {
            return null;
            // return <Modal id="addToBasketModal" body={<LoadingSpinner />} buttons={[]} />
        }

        var buttons = [
            {
                id: "1",
                text: "Confirm",
                classes: "btn-primary",
                onClick: this.onConfirm.bind(this)
            },
            {
                id: "2",
                text: "Cancel",
                classes: "btn-light",
                onClick: () => {
                    PubSub.pub("libsCheckoutCancelGrid", this.props.data.prId);
                    PubSub.pub("forSchoolCheckoutCancelGrid", this.props.data.prId);
                    PubSub.pub("addToBasketModal_close");
                }
            }
        ];

        if (this.props.data && this.props.data.showStockCategories && this.props.data.internal == 1) {
            buttons.push({
                id: "3",
                text: "Budget outcome",
                classes: "btn-primary",
                onClick: () => {
                    PubSub.pub("budgetModal", this.props.data.basketId, this.props.data.data.map(basketBranch => ({
                        ...basketBranch,
                        items: basketBranch.quantity,
                        total: (Number(basketBranch.price) + Number(basketBranch.servicing)) * Number(basketBranch.quantity),
                        stockCategoryId: basketBranch.stockCategory
                    })), this.props.data.prId)
                }
            });
        }

        const navnext = document.querySelector(".productNav.navNext");
        if (navnext || (document.querySelector("#checkoutSections") && this.props.data.availability)) {
            buttons.push({
                id: "4",
                text: "Save and go to next",
                classes: "btn-primary",
                onClick: () => {
                    this.onConfirm(true);
                }
            });
        }

        /* const body = <React.Suspense fallback={<LoadingSpinner />}>
            <OrderingGrid fromBookshelf={this.props.fromBookshelf} data={this.props.data} getItemServicingTotal={this.props.getItemServicingTotal} />
        </React.Suspense> */

        const body = <OrderingGrid fromBookshelf={this.props.fromBookshelf} basketBuilderData={this.props.basketBuilderData} data={this.props.data} getItemServicingTotal={this.props.getItemServicingTotal} />;

        return (<>
            <Modal id="addToBasketModal" body={body} heading={this.props.data.basketName} buttons={buttons} onCancelCallback={()=>{
                PubSub.pub("libsCheckoutCancelGrid", this.props.data.prId);
                PubSub.pub("forSchoolCheckoutCancelGrid", this.props.data.prId);
            }} />
            {this.props.data.showStockCategories && this.props.data.internal == 1 && <BudgetModal />}
        </>);
    }
}
 
export default OrderingGridModal;